"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionDeletePermission = exports.questionEditPermission = exports.questionReadPermission = void 0;
const QuestionUserRelationState_1 = require("../schema/QuestionUserRelationState");
const plex_1 = require("./plex");
function switchOnQuestionUserRelationState(currentUserRelation, { ownDraft, draft, ownInternal, internal, published, ignored }) {
    switch (currentUserRelation) {
        case QuestionUserRelationState_1.QuestionUserRelationState.OwnDraft:
            return ownDraft();
        case QuestionUserRelationState_1.QuestionUserRelationState.Draft:
            return draft();
        case QuestionUserRelationState_1.QuestionUserRelationState.OwnInternal:
            return ownInternal();
        case QuestionUserRelationState_1.QuestionUserRelationState.Internal:
            return internal();
        case QuestionUserRelationState_1.QuestionUserRelationState.Published:
            return published();
        case QuestionUserRelationState_1.QuestionUserRelationState.Ignored:
            return ignored();
    }
}
function questionReadPermission(currentUserRelation) {
    return switchOnQuestionUserRelationState(currentUserRelation, {
        ownDraft: () => plex_1.Permission.READ_OWN_DRAFT_QUESTION,
        draft: () => null,
        ownInternal: () => plex_1.Permission.READ_OWN_INTERNAL_QUESTION,
        internal: () => plex_1.Permission.READ_INTERNAL_QUESTION,
        published: () => plex_1.Permission.READ_PUBLISHED_QUESTION,
        ignored: () => plex_1.Permission.MANAGE_PLEX_QUESTION_TEMPLATE,
    });
}
exports.questionReadPermission = questionReadPermission;
function questionEditPermission(currentUserRelation) {
    return switchOnQuestionUserRelationState(currentUserRelation, {
        ownDraft: () => plex_1.Permission.EDIT_OWN_DRAFT_QUESTION,
        draft: () => null,
        ownInternal: () => plex_1.Permission.EDIT_OWN_INTERNAL_QUESTION,
        internal: () => plex_1.Permission.EDIT_INTERNAL_QUESTION,
        published: () => plex_1.Permission.EDIT_PUBLISHED_QUESTION,
        ignored: () => null,
    });
}
exports.questionEditPermission = questionEditPermission;
function questionDeletePermission(currentUserRelation) {
    return switchOnQuestionUserRelationState(currentUserRelation, {
        ownDraft: () => plex_1.Permission.DELETE_OWN_DRAFT_QUESTION,
        draft: () => null,
        ownInternal: () => plex_1.Permission.DELETE_OWN_INTERNAL_QUESTION,
        internal: () => plex_1.Permission.DELETE_INTERNAL_QUESTION,
        published: () => plex_1.Permission.DELETE_PUBLISHED_QUESTION,
        ignored: () => plex_1.Permission.MANAGE_PLEX_QUESTION_TEMPLATE,
    });
}
exports.questionDeletePermission = questionDeletePermission;
//# sourceMappingURL=question.js.map